import {
  normalizeImobdeskApiBase,
  readImobdeskApiEnvRaw,
  resolveImobdeskApiUrl,
} from '@imobdesk/env'
import { resolveApiBaseUrl } from '@imobdesk/api-client'
import { getImobdeskEnvRecord } from '@/lib/imobdesk-env-record'

const envRecord = getImobdeskEnvRecord()

const envApiUrl = readImobdeskApiEnvRaw(envRecord)
const isProduction = import.meta.env.PROD
const isLocalhost =
  envApiUrl?.includes('localhost') || envApiUrl?.includes('127.0.0.1')

if (isProduction) {
  if (isLocalhost) {
    console.error(
      '[API Config] ERRO: VITE_IMOBDESK_API_URL está configurada com localhost em produção!',
    )
    console.error(
      '[API Config] Configure VITE_IMOBDESK_API_URL no Cloudflare Pages com a URL da API de produção.',
    )
  } else if (!envApiUrl) {
    console.warn(
      '[API Config] AVISO: VITE_IMOBDESK_API_URL não está definida em produção!',
    )
    console.warn(
      '[API Config] Configure VITE_IMOBDESK_API_URL no Cloudflare Pages.',
    )
    console.warn(
      '[API Config] Usando endpoint relativo como fallback. Certifique-se de que isso está correto.',
    )
  }
}

export const API_BASE_URL = resolveApiBaseUrl({
  baseUrl: resolveImobdeskApiUrl(envRecord, {
    isDev: import.meta.env.DEV,
    useDevProxyForLocalhost: true,
  }),
  isDev: import.meta.env.DEV,
  devProxyForLocalhost: true,
  rawEnvUrl: envApiUrl,
})

/**
 * Base para Socket.IO. Em dev com proxy Vite, HTTP usa origem relativa (`/api`),
 * mas WebSocket precisa do host real do Nest (o proxy do Vite não cobre namespaces).
 */
export const SOCKET_API_BASE_URL =
  (envApiUrl ? normalizeImobdeskApiBase(envApiUrl) : '') ||
  API_BASE_URL ||
  'http://localhost:3030'
